import type { ProtoWallet } from '@ducat-unit/client-sdk';

export type { SnapWalletAccountRecord, SnapWalletInventory } from './connector-metamask-snap';
export { detectMetaMaskProvider, hasMetaMaskProvider } from './metamask-provider';
export { snapInventoryAssets, snapInventoryFunds } from './snap-wallet-inventory';

type SnapImplementation = typeof import('./connector-metamask-snap');
let loaded: SnapImplementation | undefined;
let pending: Promise<SnapImplementation> | undefined;
export function loadSnapImplementation(): Promise<SnapImplementation> {
  pending ??= import('./connector-metamask-snap')
    .then((module) => {
      loaded = module;
      return module;
    })
    .catch((error: unknown) => {
      pending = undefined;
      throw error;
    });
  return pending;
}
export function clearSnapWalletInventoryCache(): void {
  loaded?.clearSnapWalletInventoryCache();
}
export async function getSnapWalletInventory(client?: ProtoWallet, options: { forceRefresh?: boolean } = {}) {
  return (await loadSnapImplementation()).getSnapWalletInventory(client, options);
}
export async function getSnapWalletAccount(client?: ProtoWallet) {
  return (await loadSnapImplementation()).getSnapWalletAccount(client);
}
export async function updateMetaMaskSnap() {
  return (await loadSnapImplementation()).updateMetaMaskSnap();
}
